import styles from "./styles";
import { VeryInput } from "../common/v2/VeryInput";
import { VeryInputTel } from "../common/v2/VeryInputTel";
import { useState, useEffect } from "react";
import { classVeryInput } from "../common/v2/VeryInput/classVeryInput";
import {
  isArrayEmpty,
  isPositiveInt,
  isStringEmpty,
} from "../../utils/handler_validations";
import SelectYear from "./SelectYear";
import SelectColor from "./SelectColor";
import { useFormDriverContext } from "../../context/formDriver.context";
import { VeryPickerImgPdf } from "../common/v2/VeryPickerImgPdf";
import SelectAirbag from "./SelectAirbags";
import ABSCheckbox from "./ABSCheckBox";

const propsTemplate = () => ({
  CSS: [],
});

const ModalDriver = (props = propsTemplate()) => {
  const formDriver = useFormDriverContext();
  const customCSS = ["ModalAddDriver"];

  console.log("ModalDriver", formDriver);

  if (!isArrayEmpty(props.CSS)) customCSS.push(props.CSS.join(" "));
  if (!isStringEmpty(props.className)) customCSS.push(props.className);

  return (
    <styles.DivMain
      CSS={customCSS}
      isVisible={formDriver.value.show}
      title={
        formDriver.value.modeEdit ? "Editar conductor" : "Registrar conductor"
      }
      btnMain={{
        label: formDriver.value.modeEdit
          ? "Editar conductor"
          : "Registrar conductor",
        isLoading: formDriver.value.loading,
        onClick: () => formDriver.onClickBtnMain(),
      }}
      stepSelected={formDriver.value.stepSelected}
      onClickBtnClose={() => formDriver.hideModal()}
      onChangeStepSelected={(newStep) => formDriver.updateStep(newStep)}
      steps={Object.values(formDriver.steps)}
    >
      {/* PANEL PERSONAL DATA */}
      <styles.PanelPersonal isActiveStep={formDriver.value.stepSelected === 0}>
        {/* PICKER IMG PROFILE */}
        <VeryPickerImgPdf
          title={"Fotografía del conductor"}
          isRequired
          disabledImgs={false}
          disabledPdfs={true}
          error={formDriver.errorData.profileImg}
          originalFile={formDriver.originalData.profileImg}
          onChangeFile={(selectedFile) => {
            formDriver.updateData({ profileImg: selectedFile });
          }}
          onError={(msgError) => {
            formDriver.updateErrorsData({ profileImg: msgError });
          }}
        />
        {/* INPUT NAME + LASTNAME */}
        <div className="divName">
          <VeryInput
            CSS={["divInputName"]}
            isEditable
            isRequired
            placeHolder="Ingresa el nombre"
            text={formDriver.data.name}
            textError={formDriver.errorData.name}
            type={classVeryInput.TYPE_INPUT.NORMAL}
            title="Nombre"
            onChangeText={(newText) => formDriver.updateData({ name: newText })}
          />
          <VeryInput
            CSS={["divInputLastName"]}
            isEditable
            isRequired
            placeHolder="Ingresa los apellidos"
            text={formDriver.data.lastName}
            textError={formDriver.errorData.lastName}
            type={classVeryInput.TYPE_INPUT.NORMAL}
            title="Apellidos"
            onChangeText={(newText) =>
              formDriver.updateData({ lastName: newText })
            }
          />
        </div>
        {/* INPUT EMAIL */}
        <VeryInput
          CSS={["divInputEmail"]}
          isEditable={!formDriver.value.modeEdit}
          isRequired={!formDriver.value.modeEdit}
          placeHolder="Ingresa el correo"
          text={formDriver.data.email}
          textError={formDriver.errorData.email}
          type={classVeryInput.TYPE_INPUT.NORMAL}
          title="Correo electrónico"
          onChangeText={(newText) => {
            formDriver.updateData({ email: newText });
          }}
        />
        {/* INPUT TEL */}
        <VeryInputTel
          CSS={["divInputTel"]}
          isEditable={!formDriver.value.modeEdit}
          isRequired={!formDriver.value.modeEdit}
          text={formDriver.data.tel}
          textError={formDriver.errorData.tel}
          onChangeText={(newText) => {
            formDriver.updateData({ tel: newText });
          }}
        />
      </styles.PanelPersonal>

      {/* PANEL VEHICLE DATA */}
      <styles.PanelVehicle isActiveStep={formDriver.value.stepSelected === 1}>
        {/* INPUT MODEL */}
        <VeryInput
          CSS={["divinputModel"]}
          isEditable
          isRequired
          placeHolder="Ingresa la marca y modelo del auto"
          text={formDriver.data.vehicleModel}
          textError={formDriver.errorData.vehicleModel}
          type={classVeryInput.TYPE_INPUT.NORMAL}
          title="Marca / Modelo"
          onChangeText={(newText) => {
            formDriver.updateData({ vehicleModel: newText });
          }}
        />
        {/* SELECT YEAR + SELECT COLOR */}
        <div className="divSelects">
          <SelectYear
            textError={formDriver.errorData.vehicleYear}
            selectedYear={formDriver.data.vehicleYear}
            onChangeYear={(newYear) => {
              formDriver.updateData({ vehicleYear: newYear });
            }}
          />
          <SelectColor
            textError={formDriver.errorData.vehicleColor}
            selectedValue={formDriver.data.vehicleColor}
            onChangeValue={(newValue) => {
              formDriver.updateData({ vehicleColor: newValue });
            }}
          />
        </div>
        {/* SELECT AIRBAGS + ABS */}
        <div className="divSelects">
          <SelectAirbag
            textError={formDriver.errorData.vehicleAirbags}
            selectedVehicleAirbags={formDriver.data.vehicleAirbags}
            onChangeVehicleAirbags={(newAirbag) => {
              formDriver.updateData({ vehicleAirbags: newAirbag });
            }}
          />
          <ABSCheckbox
            title="Sistema de frenos"
            textError={formDriver.errorData.vehicleABS}
            hasABS={formDriver.data.vehicleABS}
            onChangeABS={(newABS) => {
              formDriver.updateData({ vehicleABS: newABS });
            }}
          />
        </div>
        {/* INPUT ECONOMIC NUMBER  */}
        <VeryInput
          CSS={["divInputPlates"]}
          isEditable
          placeHolder="Ingresa el numero economico del auto"
          text={formDriver.data.vehicleEconomicNumber}
          textError={formDriver.errorData.vehicleEconomicNumber}
          type={classVeryInput.TYPE_INPUT.NORMAL}
          title="Numero economico"
          onChangeText={(newText) => {
            formDriver.updateData({ vehicleEconomicNumber: newText });
          }}
        />
        {/* INPUT PLATES */}
        <VeryInput
          CSS={["divInputPlates"]}
          isEditable
          placeHolder="Ingresa las placas del auto"
          text={formDriver.data.vehiclePlates}
          textError={formDriver.errorData.vehiclePlates}
          type={classVeryInput.TYPE_INPUT.NORMAL}
          title="Placas"
          onChangeText={(newText) => {
            formDriver.updateData({ vehiclePlates: newText });
          }}
        />
        {/* PICKER IMG VEHICLE */}
        <div className="divPhotos">
          <span className="spanText">Fotos del vechiculo</span>
          <div className="rowPickersFile">
            <VeryPickerImgPdf
              title={"Foto frontal"}
              isRequired
              disabledImgs={false}
              disabledPdfs={true}
              error={formDriver.errorData.vehicleFrontPhoto}
              originalFile={formDriver.originalData.vehicleFrontPhoto}
              onChangeFile={(selectedFile) => {
                formDriver.updateData({ vehicleFrontPhoto: selectedFile });
              }}
              onError={(msgError) => {
                formDriver.updateErrorsData({ vehicleFrontPhoto: msgError });
              }}
            />
            <VeryPickerImgPdf
              title={"Foto trasera"}
              isRequired
              disabledImgs={false}
              disabledPdfs={true}
              error={formDriver.errorData.vehicleBackPhoto}
              originalFile={formDriver.originalData.vehicleBackPhoto}
              onChangeFile={(selectedFile) => {
                formDriver.updateData({ vehicleBackPhoto: selectedFile });
              }}
              onError={(msgError) => {
                formDriver.updateErrorsData({ vehicleBackPhoto: msgError });
              }}
            />
          </div>
          <div className="rowPickersFile">
            <VeryPickerImgPdf
              title={"Foto lateral izquierda"}
              disabledImgs={false}
              disabledPdfs={true}
              error={formDriver.errorData.vehicleLeftPhoto}
              originalFile={formDriver.originalData.vehicleLeftPhoto}
              onChangeFile={(selectedFile) => {
                formDriver.updateData({ vehicleLeftPhoto: selectedFile });
              }}
              onError={(msgError) => {
                formDriver.updateErrorsData({ vehicleLeftPhoto: msgError });
              }}
            />
            <VeryPickerImgPdf
              title={"Foto lateral derecha"}
              disabledImgs={false}
              disabledPdfs={true}
              error={formDriver.errorData.vehicleRightPhoto}
              originalFile={formDriver.originalData.vehicleRightPhoto}
              onChangeFile={(selectedFile) => {
                formDriver.updateData({ vehicleRightPhoto: selectedFile });
              }}
              onError={(msgError) => {
                formDriver.updateErrorsData({ vehicleRightPhoto: msgError });
              }}
            />
          </div>
        </div>
      </styles.PanelVehicle>

      {/* PANEL DOCUMENTS */}
      <styles.PanelDocumentsVehicle
        isActiveStep={formDriver.value.stepSelected === 2}
      >
        {/* WARNING TEXT */}
        <label className="txtWarning">
          Por cuestiones de seguridad para todos nuestros usuarios, es necesario
          que los conductores cumplan con estos requisitos
        </label>
        {/* INE + LICENCE */}
        <div className="divPickersFile">
          {/* CIRCULACION + POLIZA  */}
          <div className="rowPickersFile">
            <VeryPickerImgPdf
              title={"Tarjeta de circulación vigente"}
              isRequired
              disabledImgs={false}
              disabledPdfs={false}
              error={formDriver.errorData.circulationCard}
              originalFile={formDriver.originalData.circulationCard}
              onChangeFile={(selectedFile) => {
                formDriver.updateData({ circulationCard: selectedFile });
              }}
              onError={(msgError) => {
                formDriver.updateErrorsData({ circulationCard: msgError });
              }}
            />
            <VeryPickerImgPdf
              title={"Poliza de seguro (EnRed)"}
              isRequired
              disabledImgs={false}
              disabledPdfs={false}
              error={formDriver.errorData.insurensePolicy}
              originalFile={formDriver.originalData.insurensePolicy}
              onChangeFile={(selectedFile) => {
                formDriver.updateData({ insurensePolicy: selectedFile });
              }}
              onError={(msgError) => {
                formDriver.updateErrorsData({ insurensePolicy: msgError });
              }}
            />
          </div>
        </div>
      </styles.PanelDocumentsVehicle>
      {/* PANEL DOCUMENTS DRIVER */}
      <styles.PanelDocumentsDriver
        isActiveStep={formDriver.value.stepSelected === 3}
      >
        {/* WARNING TEXT */}
        <label className="txtWarning">
          Por cuestiones de seguridad para todos nuestros usuarios, es necesario
          que los conductores cumplan con estos requisitos
        </label>
        {/* INE + LICENCE */}
        <div className="divPickersFile">
          <div className="rowPickersFile">
            <VeryPickerImgPdf
              title={"INE"}
              isRequired
              disabledImgs={false}
              disabledPdfs={false}
              error={formDriver.errorData.ine}
              originalFile={formDriver.originalData.ine}
              onChangeFile={(selectedFile) => {
                formDriver.updateData({ ine: selectedFile });
              }}
              onError={(msgError) => {
                formDriver.updateErrorsData({ ine: msgError });
              }}
            />
            <VeryPickerImgPdf
              title={"Licencia de manejo"}
              isRequired
              disabledImgs={false}
              disabledPdfs={false}
              error={formDriver.errorData.driverLicence}
              originalFile={formDriver.originalData.driverLicence}
              onChangeFile={(selectedFile) => {
                formDriver.updateData({ driverLicence: selectedFile });
              }}
              onError={(msgError) => {
                formDriver.updateErrorsData({ driverLicence: msgError });
              }}
            />
          </div>
          {/* DOMICILIO*/}
          <div className="rowPickersFile">
            <VeryPickerImgPdf
              title={"Comprobante de domicilio"}
              disabledImgs={false}
              disabledPdfs={false}
              error={formDriver.errorData.address}
              originalFile={formDriver.originalData.address}
              onChangeFile={(selectedFile) => {
                formDriver.updateData({ address: selectedFile });
              }}
              onError={(msgError) => {
                formDriver.updateErrorsData({ address: msgError });
              }}
            />
          </div>
        </div>
      </styles.PanelDocumentsDriver>
    </styles.DivMain>
  );
};

export default ModalDriver;
